// Consentik renders inside a shadow root. Theme CSS cannot reach its banner.
// Keep the complete text scrollable and both native choices visible on short screens.
(() => {
  const compact = matchMedia('(max-width: 768px) and (max-height: 700px)');
  const styleId = 'mbito-consent-layout';
  const originals = new WeakMap();
  const css = `@media (max-width: 768px) and (max-height: 700px) {
  #ot-cookie-banner[data-mbito-compact-consent] .cb__inner {
    box-sizing: border-box !important;
    height: 44vh !important;
    height: 44svh !important;
    padding: 12px 16px !important;
    display: grid !important;
    grid-template-columns: minmax(0, 1fr) !important;
    grid-template-rows: minmax(0, 1fr) auto auto auto !important;
    gap: 8px !important;
  }
  #ot-cookie-banner[data-mbito-compact-consent] .cb__text-block {
    min-height: 0 !important;
    overflow: auto !important;
    overscroll-behavior: contain;
  }
  #ot-cookie-banner[data-mbito-compact-consent] .cb__after-text,
  #ot-cookie-banner[data-mbito-compact-consent] .cookie-banner__message,
  #ot-cookie-banner[data-mbito-compact-consent] .cst-brandmark {
    margin: 0 !important;
  }
  #ot-cookie-banner[data-mbito-compact-consent] #cookies-action {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: 8px !important;
    margin: 0 !important;
  }
  #ot-cookie-banner[data-mbito-compact-consent] .cookie-banner__actions-right {
    display: contents !important;
  }
  #ot-cookie-banner[data-mbito-compact-consent] #cookies-preferences,
  #ot-cookie-banner[data-mbito-compact-consent] #cookies-submit {
    grid-column: auto !important;
    width: 100% !important;
    min-height: 44px !important;
    margin: 0 !important;
    padding: 8px !important;
    white-space: normal !important;
  }
}
`;

  const attach = () => {
    const root = document.getElementById('cst-shadow-host')?.shadowRoot;
    if (!root) return;
    hostObserver.disconnect();
    const update = () => {
      if (!root.getElementById(styleId)) {
        const style = document.createElement('style');
        style.id = styleId;
        style.textContent = css;
        root.append(style);
      }
      const banner = root.querySelector('#cookies-wrapper.cst-position-full-bottom #ot-cookie-banner.cb--simple');
      if (!banner) return;
      banner.setAttribute('data-mbito-compact-consent', '');
      const text = banner.querySelector('.cb__text-block');
      if (!text) return;
      if (!originals.has(text)) originals.set(text, text.getAttribute('tabindex'));
      if (compact.matches) text.tabIndex = 0;
      else if (originals.get(text) === null) text.removeAttribute('tabindex');
      else text.setAttribute('tabindex', originals.get(text));
    };
    const bannerObserver = new MutationObserver(update);
    bannerObserver.observe(root, { childList: true, subtree: true });
    compact.addEventListener('change', update);
    update();
  };
  const hostObserver = new MutationObserver(attach);
  hostObserver.observe(document.body, { childList: true });
  attach();
})();
